// extracted by mini-css-extract-plugin
export default {"container":"TrailingBadge-module__container--SrPiH","label":"TrailingBadge-module__label--GYsDy","title":"TrailingBadge-module__title--x5Q7Q"};